// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MaBI","title":"Header_title__1rtFI","side":"Header_side__2jkLI"};